// extracted by mini-css-extract-plugin
export default {"label":"label__1VMop","textinput":"textinput__YGHHS"};